<div class="modal">
  <div class="modal-content">
    <div class="modal-header">Authentification Pro Santé Connect</div>
    <div class="modal-body">
      <app-select-practice-location
        [practiceLocations]="practiceLocations"
        (selectLocation)="validate($event)"
        (cancelSelection)="close()"
      ></app-select-practice-location>
    </div>
  </div>
</div>
<div class="modal-background"></div>
